/**
 * @method getPixelsForPercentageOfDocument
 * @param {Element} frame
 * @param {Number} percentage between 0 and 1
 * @returns {Number} pixel offset
 */
const getPixelsForPercentageOfDocument = (frame, percentage) => {
  const activeContainer = frame.parentElement;
  const frameParent = activeContainer.parentElement;

  const result = Math.round(
    percentage * (frameParent.scrollHeight - frameParent.offsetHeight),
  );

  return result;
};

export default getPixelsForPercentageOfDocument;
